.form-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: calc(var(--sc-form-row-spacing, 0.75em) * 2.5);
}

::slotted(*) {
  flex: 1;
  width: 0;
}
